/**
 * Mock settings service.
 * Mirrors the real settings.service.js API with in-memory data.
 */
import { mockDelay, mockLog } from './mock-delay';

// In-memory stores
let notificationPrefs = {
  likes: true,
  comments: true,
  newFollowers: true,
  achievementUnlocks: true,
  partnerReminders: true,
  streakMilestones: true,
  workoutShares: true,
  muteAll: false,
};

let privacySettings = {
  profileVisibility: 'public',
  showWorkoutStats: true,
  showBodyStats: true,
};

// ── Notification Preferences ──────────────────────────────────────────────────

export const getNotificationPreferences = async (userId) => {
  mockLog('SettingsService', 'getNotificationPreferences', userId);
  await mockDelay();
  return { ...notificationPrefs };
};

export const updateNotificationPreferences = async (userId, prefs) => {
  mockLog('SettingsService', 'updateNotificationPreferences', { userId, prefs });
  await mockDelay(100, 300);
  notificationPrefs = { ...notificationPrefs, ...prefs };
  return { ...notificationPrefs };
};

// ── Privacy Settings ──────────────────────────────────────────────────────────

export const getPrivacySettings = async (userId) => {
  mockLog('SettingsService', 'getPrivacySettings', userId);
  await mockDelay();
  return { ...privacySettings };
};

export const updatePrivacySettings = async (userId, settings) => {
  mockLog('SettingsService', 'updatePrivacySettings', { userId, settings });
  await mockDelay(100, 300);
  privacySettings = { ...privacySettings, ...settings };
  return { ...privacySettings };
};

// ── Theme & Date Preferences ──────────────────────────────────────────────────

export const updateThemePreference = async (userId, theme) => {
  mockLog('SettingsService', 'updateThemePreference', { userId, theme });
  await mockDelay(50, 150);
};

export const updateDateFormat = async (userId, format) => {
  mockLog('SettingsService', 'updateDateFormat', { userId, format });
  await mockDelay(50, 150);
};

// ── Password Change ───────────────────────────────────────────────────────────

export const changePassword = async (currentPassword, newPassword) => {
  mockLog('SettingsService', 'changePassword', '***');
  await mockDelay(300, 600);
  // Simulate success in mock mode
  if (currentPassword === 'wrong') {
    throw new Error('Incorrect password.');
  }
};

// ── Account Deletion ──────────────────────────────────────────────────────────

export const deleteAccount = async (userId, currentPassword) => {
  mockLog('SettingsService', 'deleteAccount', userId);
  await mockDelay(500, 800);
  if (currentPassword === 'wrong') {
    throw new Error('Incorrect password.');
  }
  // In mock mode, just log - don't actually do anything destructive
};
